import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum SidebarTask {
  UPLOAD_W9 = 'upload-w9',
  REVIEW_PAYMENT_SCHEDULE = 'review-payment-schedule',
  CONNECT_BANK = 'connect-bank',
  UPLOAD_BANK_DOC = 'upload-bank-doc',
  BANK_VERIFICATION = 'bank-verification',
  REVIEW_MSA = 'review-msa',
  ACCEPT_DATA_SHARING_AGREEMENT = 'accept-data-sharing-agreement',
}

export interface OnboardingSidebarState {
  selectedTask?: SidebarTask;
}

const initialState: OnboardingSidebarState = {
  selectedTask: SidebarTask.UPLOAD_W9,
};

const onboardingSidebarSlice = createSlice({
  name: 'onboardingSidebar',
  initialState,
  reducers: {
    updateSelectedTask(state: OnboardingSidebarState, action: PayloadAction<SidebarTask | undefined>) {
      state.selectedTask = action.payload;
    },
  },
});

export const {
  updateSelectedTask,
} = onboardingSidebarSlice.actions;
export default onboardingSidebarSlice.reducer;
